export const COOKIE_CONSENT_KEY = 'swapify_cookie_preferences';
export const OPEN_COOKIE_SETTINGS_EVENT = 'swapify:open-cookie-settings';

export const DEFAULT_COOKIE_PREFERENCES = {
  necessary: true,
  analytics: false,
  consentGiven: false,
  updatedAt: null,
};

export function getCookiePreferences() {
  if (typeof window === 'undefined') {
    return DEFAULT_COOKIE_PREFERENCES;
  }

  try {
    const stored = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) {
      return DEFAULT_COOKIE_PREFERENCES;
    }

    const parsed = JSON.parse(stored);
    return {
      ...DEFAULT_COOKIE_PREFERENCES,
      ...parsed,
      necessary: true,
    };
  } catch (error) {
    console.error('Failed to read cookie preferences:', error);
    return DEFAULT_COOKIE_PREFERENCES;
  }
}

export function saveCookiePreferences(preferences) {
  if (typeof window === 'undefined') {
    return DEFAULT_COOKIE_PREFERENCES;
  }

  const nextPreferences = {
    ...DEFAULT_COOKIE_PREFERENCES,
    ...preferences,
    necessary: true,
    consentGiven: true,
    updatedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(nextPreferences));
  window.dispatchEvent(new CustomEvent('swapify:cookie-preferences-changed', {
    detail: nextPreferences,
  }));
  return nextPreferences;
}

export function openCookieSettings() {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
}
